import { render, staticRenderFns } from "./Footer.html?vue&type=template&id=55b13123&scoped=true&"
import script from "./Footer.ts?vue&type=script&lang=ts&"
export * from "./Footer.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/footer/_footer.scss?vue&type=style&index=0&id=55b13123&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b13123",
  null
  
)

export default component.exports